import { ReactNode, useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { store } from '../../store'
import { RootState } from '../../store/modules/rootReducer'
import { switchColorMode } from '../../store/modules/theme/actions'
import { darkTheme, lightTheme } from '../../styles/themes'

interface DarkThemeProps {
  children: ReactNode
}

export function DarkThemeProvider({ children }: DarkThemeProps) {
  // Comment until dark mode colors are available

  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  const handleInitialThemePreference = useCallback(() => {
    if (isDarkMode === null) {
      const prefersDark =
        window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      store.dispatch(switchColorMode({ isDarkMode: prefersDark ? true : false }))
    }
  }, [isDarkMode])

  useEffect(() => {
    handleInitialThemePreference()
  }, [handleInitialThemePreference])

  return <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>{children}</ThemeProvider>
  // return <ThemeProvider theme={lightTheme}>{children}</ThemeProvider>
}
